import {MapLayer} from "./map-layer.model";
import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';

interface FetchMapLayersResponse {
  data: {
    mapLayers: MapLayer[];
  };
}

interface SingleMapLayerResponse {
  data: MapLayer;
}

@Injectable({
  providedIn: 'root',
})
export class MapLayerService {
  constructor(private apiService: ApiService) {}

  async fetch(): Promise<MapLayer[]> {
    const response = await this.apiService.get<FetchMapLayersResponse>('/map-layer');
    return this.parseMapLayers(response.data.mapLayers);
  }

  async fetchById(mapLayerId: string): Promise<MapLayer> {
    const response = await this.apiService.get<SingleMapLayerResponse>(`/map-layer/${mapLayerId}`);
    return response.data;
  }

  async create(mapLayerData: MapLayer): Promise<MapLayer> {
    const response = await this.apiService.post<SingleMapLayerResponse>('/map-layer', mapLayerData);
    return response.data;
  }

  async update(mapLayerData: MapLayer): Promise<MapLayer> {
    const response = await this.apiService.put<SingleMapLayerResponse>(
      `/map-layer/${mapLayerData.id}`,
      mapLayerData
    );
    return response.data;
  }

  async delete(mapLayerId: string): Promise<void> {
    await this.apiService.delete(`/map-layer/${mapLayerId}`);
  }

  private parseMapLayers(mapLayers: MapLayer[]): any {
    return mapLayers.map((layer) => {
      const jsonContent = layer.jsonContent
          ? JSON.parse(layer.jsonContent)
          : {};
      jsonContent.id = layer.id;

      return {
        ...layer,
        jsonContent: jsonContent,
        jsonMetadata: layer.jsonMetadata
            ? JSON.parse(layer.jsonMetadata)
            : {},
      };
    });
  }
}
